var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("page-title-area", [_c("h1", [_vm._v(_vm._s(_vm.$t("title")))])]),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mb-5", attrs: { outlined: "" } },
        [
          _c(
            "v-card-text",
            {
              staticClass: "d-flex align-center flex-wrap",
              staticStyle: { gap: "16px" },
            },
            [
              _c(
                "div",
                { staticClass: "control-group" },
                [
                  _c("span", { staticClass: "control-group__label" }, [
                    _vm._v(_vm._s(_vm.$t("label.interval"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn-toggle",
                    {
                      attrs: { mandatory: "", dense: "", color: "primary" },
                      model: {
                        value: _vm.slotMinutes,
                        callback: function ($$v) {
                          _vm.slotMinutes = $$v
                        },
                        expression: "slotMinutes",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { value: _vm.SLOT_MINUTES.FIFTEEN, small: "" },
                        },
                        [_vm._v("15" + _vm._s(_vm.$t("unit.min")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { value: _vm.SLOT_MINUTES.THIRTY, small: "" },
                        },
                        [_vm._v("30" + _vm._s(_vm.$t("unit.min")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { value: _vm.SLOT_MINUTES.SIXTY, small: "" } },
                        [_vm._v("1" + _vm._s(_vm.$t("unit.hour")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "control-group" },
                [
                  _c("span", { staticClass: "control-group__label" }, [
                    _vm._v(_vm._s(_vm.$t("label.filter"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn-toggle",
                    {
                      attrs: { mandatory: "", dense: "", color: "primary" },
                      model: {
                        value: _vm.filterMode,
                        callback: function ($$v) {
                          _vm.filterMode = $$v
                        },
                        expression: "filterMode",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { value: "exclude_misdetection", small: "" } },
                        [_vm._v(_vm._s(_vm.$t("filter.exclude_misdetection")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { value: "pickup_only", small: "" } },
                        [_vm._v(_vm._s(_vm.$t("filter.pickup_only")))]
                      ),
                      _vm._v(" "),
                      _c("v-btn", { attrs: { value: "all", small: "" } }, [
                        _vm._v(_vm._s(_vm.$t("filter.all"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "control-group" },
                [
                  _c("span", { staticClass: "control-group__label" }, [
                    _vm._v(_vm._s(_vm.$t("label.date"))),
                  ]),
                  _vm._v(" "),
                  _c("date-picker-dropdown", {
                    attrs: {
                      type: "date",
                      value: _vm.selectedDate,
                      max: _vm.today,
                    },
                    on: {
                      input: function ($event) {
                        _vm.selectedDate = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          var displayValue = ref.displayValue
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "date-btn",
                                    attrs: { outlined: "", small: "" },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("fa-calendar"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(displayValue) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading && _vm.placeSensors.length === 0
        ? _c("v-alert", { attrs: { type: "info", outlined: "" } }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$mpt(_vm.$t("msg.no_sensors"))) + "\n  "
            ),
          ])
        : _c(
            "v-card",
            { attrs: { outlined: "" } },
            [
              _c(
                "v-card-text",
                {
                  ref: "heatmapContainer",
                  staticStyle: { position: "relative" },
                },
                [
                  _c(
                    "v-overlay",
                    { attrs: { value: _vm.loading, absolute: "" } },
                    [_c("page-load-spinner")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "timeline-scroll" },
                    [
                      _vm._l(_vm.sensorSections, function (section, index) {
                        return [
                          _c(
                            "div",
                            {
                              key: "header-" + section.type,
                              staticClass:
                                "section-header d-flex align-center text-nowrap",
                              class: { "mt-8": index > 0 },
                              attrs: { "data-testid": "sensor-section-header" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(section.label) +
                                  "\n            "
                              ),
                              section.type === _vm.SENSOR_TYPES.RAT_SENSE
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "", "max-width": "300" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          "x-small": "",
                                                          "aria-label":
                                                            _vm.ratSenseNotice,
                                                          "data-testid":
                                                            "rat-sense-notice-icon",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                  mdi-information-outline\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "rat-sense-notice" },
                                        [_vm._v(_vm._s(_vm.ratSenseNotice))]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("timeline-heatmap", {
                            key: "heatmap-" + section.type,
                            attrs: {
                              sensors: section.sensors,
                              minutes: _vm.slotMinutes,
                              events: _vm.filteredEvents,
                              clickable: _vm.hasMedia(section.type),
                              "show-legend":
                                index === _vm.sensorSections.length - 1,
                            },
                            on: {
                              "cell-hover": _vm.onCellHover,
                              "cell-leave": _vm.onCellLeave,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("timeline-popup", {
                    attrs: {
                      visible: _vm.popup.visible,
                      event: _vm.popup.event,
                      "sensor-name": _vm.popup.sensorName,
                      "time-label": _vm.popup.timeLabel,
                      count: _vm.popup.count,
                      position: _vm.popup.position,
                      "activity-link": _vm.activityLink,
                      detailed: _vm.popup.detailed,
                    },
                    on: {
                      "popup-enter": _vm.onPopupEnter,
                      "popup-leave": _vm.onPopupLeave,
                      "show-gallery": _vm.showGallery,
                    },
                  }),
                  _vm._v(" "),
                  _c("gallery-view", {
                    attrs: {
                      displayData: _vm.galleryData,
                      requestParams: _vm.galleryRequestParams,
                    },
                    on: { eventUpdated: _vm.onEventUpdated },
                    model: {
                      value: _vm.galleryVisible,
                      callback: function ($$v) {
                        _vm.galleryVisible = $$v
                      },
                      expression: "galleryVisible",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }